import { useState, useEffect } from 'react'
import { ProcessInfo } from '@aicoding/micro-bridge'
import { triggerWorkflow } from '@/service'
import { loadStoredSCode } from '@/components/ProjectSCodeModal'

const assetVersionCode = process.env.VERSION_CODE as string

export function useWorkflow() {
  const [loading, setLoading] = useState(true)
  const [processInfo, setProcessInfo] = useState<ProcessInfo>()

  useEffect(() => {
    // 优先使用弹窗保存的项目 S 码（localStorage），否则使用构建时注入的 ASSET_CODE
    const assetCode = loadStoredSCode() || (process.env.ASSET_CODE as string)

    triggerWorkflow({ assetCode, assetVersionCode }).then((data) => {
      setProcessInfo(data)
      setLoading(false)
    })
  }, [])

  return { loading, processInfo }
}
